export const actionMatches = (message: { action: string }, action: string): boolean => {
    if (!message || !message.action) {
        return false
    }
    if (message.action === action) {
        return true;
    }

    return message.action.endsWith('-' + action);
};